export const format = {
    text: e => e.value,
    licensePlate: e => e.value.replace(/[^A-Z0-9]/ig, '').slice(0, 7).toUpperCase(),
    phone: e => e.value.replace(/\D/g, ''),
    postalCode: e => e.value.replace(/\D/g, ''),
    integer: e => parseInt(e.value.replace(/\D/g, '')),
    checkbox: e => e.checked,

    view: {
        licensePlate: value => {
            if (value.length > 2) {
                const spaces = window.innerWidth >= 1024 ? '    ' : '  ';
                value = value.slice(0, 2) + spaces + value.slice(2);
            }

            return value;
        },
        phone: value => {
            const space = pos => value.slice(0, pos) + ' ' + value.slice(pos);

            if (value.length > 4)
                value = space(4);
            if (value.length > 8)
                value = space(8);
            if (value.length >= 12)
                value = value.slice(0, 12);

            return value;
        },
        postalCode: value => {
            const space = pos => value.slice(0, pos) + ' ' + value.slice(pos);

            if (value.length > 3)
                value = space(3);
            if (value.length >= 6)
                value = value.slice(0, 6);

            return value;
        },
    },
};
